export const formatDate = date => {
  const options = {
    month: 'long',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
  };
  const formattedDate = new Date(date).toLocaleDateString(undefined, options)?.replace(/at(?!.*at)/, '@');

  return formattedDate;
};
